"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed"));

var _aspectRatioHeights = _interopRequireDefault(require("../../../constants/aspectRatioHeights"));

var NewShot = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NewShot, _Component);

  function NewShot() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, NewShot);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(NewShot)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function () {
      var createShot = _this.props.createShot;
      createShot();
    });
    return _this;
  }

  (0, _createClass2.default)(NewShot, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isOver = _this$props.isOver,
          connectDropTarget = _this$props.connectDropTarget,
          aspectRatio = _this$props.aspectRatio;
      return connectDropTarget(_react.default.createElement("div", {
        className: "new-shot__padding-box"
      }, _react.default.createElement("div", {
        tabIndex: 0,
        role: "button",
        onKeyDown: (0, _onEnterPressed.default)({
          onClick: this.handleClick
        }),
        onClick: this.handleClick,
        className: (0, _classnames.default)('new-shot', {
          'new-shot--over': isOver
        }),
        style: {
          height: "".concat(_aspectRatioHeights.default[aspectRatio], "px")
        }
      }, _react.default.createElement(_uiKit.Icon, {
        className: "new-shot__icon",
        name: "shot",
        size: 40,
        color: isOver ? 'monkey' : 'michael'
      }), _react.default.createElement("p", {
        "data-cy": "create-new-shot",
        className: (0, _classnames.default)('new-shot__text', {
          'new-shot__text--over': isOver
        })
      }, "New Shot"))));
    }
  }]);
  return NewShot;
}(_react.Component);

var _default = NewShot;
exports.default = _default;